import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./NewbornResources.da.resx"
import { R as _en } from "./NewbornResources.en.resx"
import { R as _nb } from "./NewbornResources.nb.resx"

type Translations = {
	"UpdateDueDateButtonText": string,
	"UpdateDueDateServerSideError": string,
	"EmptyDueDateError": string,
	"SelectDate": string,
	"OutOfRangeDueDateError": string,
	"EditDueDate": string,
	"HaveYouGivenBirthTitle": string,
	"HaveYouGivenBirthParagraph1": string,
	"HaveYouGivenBirthParagraph2": string,
	"StillPregnantButtonText": string,
	"BabyBornButtonText": string,
	"BackButtonText": string,
	"CongratulationOnYourChildTitle": string,
	"CongratulationOnYourChildParagraph1": string,
	"CongratulationOnYourChildParagraph2Title": string,
	"CongratulationOnYourChildParagraph2": string,
	"CongratulationOnYourChildParagraph3Title": string,
	"CongratulationOnYourChildParagraph3": string,
	"CongratulationOnYourChildRegisterChildButtonText": string,
	"BabyIsBornButtonText": string,
	"InfoSectionHeader": string,
	"FirstTrimesterDescription": string,
	"SecondTrimesterDescription": string,
	"ThirdTrimesterDescription": string,
	"PregnantInfoHeader": string,
	"ReadAboutLink": string,
	"PregnantInfoBullet1": string,
	"PregnantInfoBullet2": string,
	"PregnantInfoBullet3": string,
	"PartnerInfoHeader": string,
	"PregnancyPartnerInfoBullet1": string,
	"PregnancyPartnerInfoBullet2": string,
	"PregnancyPartnerInfoBullet3": string,
	"GivenBirthInfoHeader": string,
	"ZeroToThreeMonthsHeader": string,
	"ZeroToThreeMonthsDescription": string,
	"ThreeToTwelveMonthsHeader": string,
	"ThreeToSixMonthsDescription": string,
	"SixToNineMonthsDescription": string,
	"NineToTwelveMonthsDescription": string,
	"AddChild": string,
	"Add": string,
	"FetchedViaCpr": string,
	"ChildSuccessfullyAddedTitle": string,
	"Close": string,
	"ChildWasSuccesfullyAddedParagraph": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

if(process.env.enforcedLocale === "nb" || (!process.env.enforcedLocale && getLocale("da") === "nb")) {
			return _nb[name] ?? name
		}

		return name
	},
}) as Translations

export { R }